<template>
  <div class="md-layout upload-button-area">
    <md-button
      class="md-fileinput md-dense md-raised md-round md-layout-item md-size-90 upload-button"
      :class="buttonClass"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <md-icon class="upload-icon">{{!uploadedFiles.length ? 'cloud_upload' : 'check' }}</md-icon>
      <input
        type="file"
        :multiple="multiple"
        @change="onFileChange"
        accept="application/pdf, image/jpeg"
      />
      {{currentInputLabel}}
    </md-button>
    <md-button
      v-if="uploadedFiles.length"
      class="md-just-icon md-simple md-danger md-layout-item md-size-10 delete-uploaded-file"
      @click="unsetUploadedFiles"
    >
      <md-icon>close</md-icon>
    </md-button>

    <template v-if="uploadedFiles.length">
      <md-list v-if="showFileList">
        <md-list-item v-for="(file, i) in uploadedFiles" :class="listLayout" :key="i">{{file.name}}</md-list-item>
      </md-list>

      <div v-else-if="showUploadedFilesLabel">
        {{uploadedFiles.length}} archivos subido{{uploadedFiles.lenght!=1 ? 's' : ''}}.
        <md-tooltip md-direction="top">{{uploadedFilesTooltip}}</md-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    inputLabel: {
      type: String,
      default: "Upload",
    },
    uploadedLabel: {
      type: String,
      default: "Uploaded",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    buttonClass: {
      type: [Array, String, Object],
      default: "",
    },
    // :TODO: Implement horizontal layout
    horizontalLayout: {
      type: Boolean,
      default: false,
    },
    showFileList: {
      type: Boolean,
      default: false,
    },
    showUploadedFilesLabel: {
      type: Boolean,
      default: false,
    },
  },

  name: "UploadButton",

  computed: {
    listLayout() {
      return { "horizontal-list": this.horizontalLayout };
    },
    uploadedFilesTooltip() {
      return this.uploadedFiles.map((f) => f.name).join(", ");
    },
    currentInputLabel() {
      if (this.uploadedFiles.length) {
        return this.uploadedLabel || this.inputLabel;
      } else {
        return this.inputLabel;
      }
    },
  },

  methods: {
    onFileChange(e) {
      e.stopPropagation();

      let files = [...(e.target.files || e.dataTransfer.files)];

      this.uploadedFiles = files;

      e.srcElement.value = null;
    },
    unsetUploadedFiles() {
      this.uploadedFiles = [];
    },
  },

  data() {
    return {
      uploadedFiles: [],
    };
  },

  watch: {
    uploadedFiles() {
      const uploadedFiles = this.uploadedFiles;
      const payload = this.multiple ? uploadedFiles : uploadedFiles[0];
      this.$emit("uploaded", payload);
    },
  },
};
</script>

<style lang="css" scoped>
.md-button.upload-button {
  border-radius: 2px;
}

.upload-button-area {
  position: relative;
}

.horizontal-list {
}

.md-button-content > .md-icon.upload-icon {
  font-size: 1.75rem !important;
}

.md-button.delete-uploaded-file {
  position: absolute;
  left: 90%;
  top: -50%;
}
</style>


// WEBPACK FOOTER //
// src/components/UploadButton.vue